import { nextFrame } from "../../../animation/nextFrame";
import { AudioMath } from "../../AudioMath";
import { AudioData } from "../../data/AudioData";
import { FloatArrayAudioData } from "../../data/FloatArrayAudioData";
import { AudioBuilderContext } from "../AudioBuilderContext";
import { Component } from "./Component";

export class SineComponent extends Component
{
  harmonicIndex = 1;
  velocityMultiply = 1;
  pitchNoiseRange = 24;
  pitchNoiseFilter = 0.2;

  async generate( context:AudioBuilderContext ):Promise<AudioData>
  {    
    let pitchCurve    = context.keyPitch;
    let velocityCurve = context.keyVelocity;

    let ad = context.createAudioData( velocityCurve.xLength );


    let phase = 0;
    let sleepSteps = context.sleepTimerCheckSteps;
    let sleepTime  = new Date().getTime(); 

    let pitchNoiseOffset = 0;
  
    for ( let i = 0; i < ad.numFrames; i++ )
    {
      if ( sleepSteps == 0 )
      {
        let timeNow = new Date().getDate();
        let elapsed = timeNow - sleepTime;

        if ( elapsed > context.sleepTimerDurationMS )
        {
          sleepTime = timeNow;
          sleepSteps = context.sleepTimerCheckSteps;
          await nextFrame();
        }
      }

      sleepSteps --;

      let time = context.samplesToDuration( i );
      let pitch = pitchCurve.getY( time );
      
      let nextPitchNoise = Math.random() * this.pitchNoiseRange;

      pitchNoiseOffset += this.pitchNoiseFilter * ( nextPitchNoise - pitchNoiseOffset ); 

      let frequency = AudioMath.midiKeyToFrequency( pitch + pitchNoiseOffset ) * this.harmonicIndex;      
      let phaseIncrement = context.frequencyToPhaseIncrement( frequency );
      let velocity = velocityCurve.getY( time ) * this.velocityMultiply;

      
      let value = Math.sin( phase * 2 * Math.PI ) * velocity;

      phase += phaseIncrement;

      ad.setAll( i, value );
    }

    return ad;

  }
}